<template lang="pug">
.app-bar-wrap
	v-layout.app-bar(
		justify-space-between
		align-center
	)
		.logo
			v-image.logo(
				src="logo.png"
				width="120"
			)
		.status(
			v-if="gameStatus"
		) 진행상태 : {{ gameStatus }} {{ time ? (gameStatus.endsWith('준비') ? `(시작까지 ${timeFormat})` : `(종료까지 ${timeFormat})`) :	''}}
		v-layout.flex-grow-0(
			column
			align-end
		)
			v-image.btn-logout(
				src="btn_logout.png"
				@click="logout"
			)
			v-layout.training.mt-2(
				v-if="admin.type === 'admin'"
				align-center
			)
				span.training_label 현재교육 :
				span {{ $adminData.training.name || '선택된 교육 없음' }}
	v-layout.gnb-wrap(align-end)
		.gnb
			v-hover(
				v-slot="{ hover }"
				v-for="(menu, index) in menus[this.admin.type]"
				:key="index"
				v-if="(!menu.index || menu.index === tabIndex) && !tabChanged"
			)
				span.menu(
					:class="tabIndex === index || tabIndex === menu.index ? 'active' : ''"
					@click="changeTab(index)"
				) {{ menu.name }} {{ menu.children ? '▼' : '' }}
					v-list.sub-menu(
						v-if="menu.children && hover"
					)
						v-list-item(
							v-for="(item, subIndex) in menu.children"
							:key="item.name"
							link
							color="#C10D12"
							@change="changeTab(index, subIndex)"
						)
							v-list-item-title(
								v-text="item.name"
							)
			v-btn(
				v-if="admin.type === 'admin'"
				color="error"
				@click="openDirectionReset"
			) 상태 초기화
	
	v-dialog(
		width="960"
		v-model="showDirectionReset"
		content-class="direction-reset"
	)
		v-card()
			v-card-title 상태 초기화
			v-card-text
				v-row.filter
					v-col(cols="4")
						v-select(
							label="팀"
							dense
							hide-details
							outlined
							:items="teams"
							v-model="directionFilter.team"
						)
					v-col.legend-col(cols="8")
						.legend-hint
							span.chip.chip-planing 진행중
							span.chip.chip-completed 완료
							span.chip.chip-resend 재전송 열람
							span.chip.chip-pending 검수 대기
						.refresh-wrap
							span.updated-at(v-if="directionUpdatedAt") {{ directionUpdatedAt }} 기준
							v-btn.btn-refresh(
								small
								outlined
								color="error"
								:disabled="!directionFilter.team"
								@click="getDirectionList()"
							) 새로고침
				.parts(v-if="directionRows.length > 0")
					.part-block(
						v-for="p in partDefs"
						:key="p.key"
					)
						.part-name {{ p.name }}
						.part-empty(v-if="partTotal(p.key) === 0") 아직 전달된 지시서가 없습니다
						template(v-else)
							v-layout.type-row(
								v-for="t in typeDefs"
								:key="`${p.key}-${t.key}`"
								align-center
								v-if="partItems(p.key, t.key).length > 0"
							)
								.type-name {{ t.name }}
								.items
									v-layout.item.justify-center.align-center(
										v-for="item in partItems(p.key, t.key)"
										:key="`${p.key}-${t.key}-${item.order}`"
										:class="itemClass(item, p.key)"
										@click="confirmReset(item, p.key)"
									) {{ t.name }}{{ item.order }}
			v-card-actions
				v-spacer
				v-btn(
					color="secondary"
					@click="showDirectionReset = false"
				) 닫기
				v-spacer


</template>

<script>
// 지시서 상태 실시간 갱신 디바운스 — 한 조작이 여러 메시지를 낳으므로 마지막 기준 1회만 읽는다
const DIRECTION_REFRESH_DEBOUNCE_MS = 300

export default {
	data() {
		return {
			menus: {
				superadmin: [
					{name: 'Client 계정 관리', path: '/manage/users'},
					{name: '교육 모니터링', path: '/manage/monitoring'},
					{name: '기본값 설정', children: [
							{name: '자본금/가격 설정', path: '/manage/setting/money'},
							{name: 'CALL 설정', path: '/manage/setting/call'},
							{name: '프로젝트 지시서 설정', path: '/manage/setting/direction'},
							{name: '운송게임 설정', path: '/manage/setting/game'},
						]
					},
					{name: '현황/결과', path: '/manage/result', index: 6},
				],
				admin: [
					{name: '교육 선택', path: '/admin/trainings'},
					{name: '교육 정보', path: '/admin/training'},
					{
						name: '기획파트', children: [
							{name: '프로젝트 지시서', path: '/admin/plan/direction'},
							{name: '완료 목록', path: '/admin/plan/completed'},
						]
					},
					{
						name: '구매파트', children: [
							{name: '운송게임 설정', path: '/admin/buy/game'},
							{name: '운송 목록', path: '/admin/buy/completed'},
						]
					},
					{
						name: '제작파트', children: [
							{name: '제작 검수', path: '/admin/make/inspection'},
							{name: '보유한 레고 목록', path: '/admin/make/owned'},
						]
					},
					{name: '포인트', path: '/admin/point'},
					{name: '현황/결과', path: '/admin/result'},
				],
			},
			tabChanged: false,
			timer: null,
			time: null,
			
			showDirectionReset: false,
			directionFilter: {},
			directionRows: [],
			pendingInspections: [],
			directionUpdatedAt: '',
			directionRefreshTimer: null,
			partDefs: [
				{ key: 'plan', name: '기획' },
				{ key: 'buy', name: '구매' },
				{ key: 'make', name: '제작' },
			],
			typeDefs: [
				{ key: 'low', name: '하' },
				{ key: 'medium', name: '중' },
				{ key: 'high', name: '상' },
			],
		}
	},
	
	computed: {
		tabIndex() {
			return this.$adminData.tabIndex
		},
		tabSubIndex() {
			return this.$adminData.tabSubIndex
		},
		admin() {
			return this.$adminData.admin
		},
		timeFormat() {
			if (!this.time) return ''
			const time = moment.utc(this.time*1000)
			if (time.unix() > 3600) return time.format('HH:mm:ss')
			return time.format('mm:ss')
		},
		teams() {
			if (!this.training) return []
			
			const teams = []
			for (let no = 1; no <= this.training.team_count; no++) {
				teams.push({
					text: no + '팀',
					value: no
				})
			}
			
			return teams
		},
		parts() {
			return [
				{ text: '기획', value: 'plan' },
				{ text: '구매', value: 'buy' },
				{ text: '제작', value: 'make' },
			]
		}
	},
	watch: {
		mqttData(val) {
			if (val) {
				if (val.action === 'round' || val.action === 'round_ended') {
					this.$set(this.$adminData.training, 'timestamp', moment().unix())
					
					this.stopTimer()
					if ([1,1.5,2].indexOf(this.round) > -1) {
						this.startTimer(this.round)
					}
				}

				// 상태 초기화 화면을 열어둔 동안에는 지시서·검수 변경을 실시간으로 반영한다.
				//   메시지 핸들러가 선택된 교육으로 이미 걸러 주므로(GameManager 의 training.id 비교)
				//   여기서는 보고 있는 팀인지만 확인한다. team 이 실려 오지 않는 메시지(검수 등)는
				//   통과시켜 재조회한다 — 놓치는 쪽보다 한 번 더 읽는 쪽이 안전하다.
				if (this.showDirectionReset && this.directionFilter.team
					&& (val.action === 'direction' || val.action === 'inspection')) {
					if (val.team === undefined || val.team === this.directionFilter.team) {
						this.reserveDirectionRefresh()
					}
				}
			}
		},
		directionFilter: {
			deep: true,
			handler(val) {
				if (val.team) {
					this.getDirectionList()
				}
			}
		},
		showDirectionReset(val) {
			// 닫힌 뒤 예약된 재조회가 남아 돌지 않게 정리한다
			if (!val && this.directionRefreshTimer) {
				clearTimeout(this.directionRefreshTimer)
				this.directionRefreshTimer = null
			}
		},
		'$adminData.training': {
			deep: true,
			handler(val) {
				// if (val.round) {
				// 	this.round = val.round
				this.stopTimer()
				this.startTimer(this.round)
				// } else {
				// 	this.stopTimer()
				// }
			}
		}
	},
	mounted() {
		if (!this.$route.path.startsWith('/manage')) {
			setTimeout(_ => {
				if (this.tabIndex > 0 && !this.$cookie.get('training_id')) {
					if (this.$route.path !== '/admin/trainings') {
						this.$router.replace('/admin/trainings')
					}
					this.$store.commit('showDialog', {
						type: 'alert',
						message: '선택된 교육이 없습니다.\n교육을 먼저 선택하세요.'
					})
				}
				
				
			}, 500)
		}
		
		this.stopTimer()
		if ([1,1.5,2].indexOf(this.round) > -1) {
			this.startTimer(this.round)
		}
	},
	
	methods: {
		changeTab(index, subIndex) {
			
			if (!this.$route.path.startsWith('/manage')) {
				if (index > 0 && !this.$cookie.get('training_id')) {
					if (this.$route.path !== '/admin/trainings') {
						this.$router.replace('/admin/trainings')
					}
					this.$store.commit('showDialog', {
						type: 'alert',
						message: '선택된 교육이 없습니다.\n교육을 먼저 선택하세요.'
					})
					return
				}
			}
			
			this.tabChanged = true
			
			setTimeout(_ => {
				this.tabChanged = false
			})
			
			const menu = this.menus[this.admin.type][index]
			
			if (subIndex === undefined) {
				if (this.tabIndex === index || this.tabIndex === menu.index) return
				if (!menu.path) return
				this.$router.push(menu.path)
			} else {
				if (this.tabIndex === index && this.tabSubIndex === subIndex) return
				const item = menu.children[subIndex]
				this.$router.push(item.path)
			}
		},
		
		logout() {
			this.$disconnect()
			this.$cookie.delete('admin_token')
			this.$cookie.delete('tpc_token')
			location.replace('/login')
		},
		
		startTimer(round) {
			const countDown = () => {
				let endTime
				if (round === 1.5) {
					if (!this.training.start_time2) {
						this.stopTimer()
						return
					}
					endTime = `${this.training.date} ${this.training[`start_time2`]}`
				} else {
					if (!this.training[`end_time${round}`]) {
						this.stopTimer()
						return
					}
					endTime = `${this.training.date} ${this.training[`end_time${round}`]}`
				}
				
				this.time = Math.ceil(moment(endTime).diff(moment()) / 1000)
				
				if (this.time <= 0) {
					this.stopTimer()
				}
			}
			this.timer = setInterval(countDown, 1000)
		},
		stopTimer() {
			if (this.timer) {
				clearInterval(this.timer)
				this.$set(this.$adminData.training, 'round', null)
				this.timer = null
				this.time = null
			}
		},
		openDirectionReset() {
			this.directionFilter = {}
			this.directionRows = []
			this.pendingInspections = []
			this.directionUpdatedAt = ''
			this.showDirectionReset = true
		},
		/**
		 * 실시간 갱신 예약(디바운스).
		 * 한 번의 조작이 여러 메시지를 낳고(열림→닫힘→전파) 팀 전체가 동시에 움직이므로,
		 * 메시지마다 재조회하면 불필요한 호출이 쏟아진다. 마지막 메시지 기준으로 한 번만 읽는다.
		 */
		reserveDirectionRefresh() {
			if (this.directionRefreshTimer) clearTimeout(this.directionRefreshTimer)
			this.directionRefreshTimer = setTimeout(() => {
				this.directionRefreshTimer = null
				if (this.showDirectionReset && this.directionFilter.team) {
					this.getDirectionList()
				}
			}, DIRECTION_REFRESH_DEBOUNCE_MS)
		},
		async getDirectionList() {
			const response = await this.$get('/admin/part/directions', {
				training_id: this.training.id,
				team: this.directionFilter.team,
			})
			if (response.code !== '0000') {
				console.error('지시서 목록 조회 실패 code =', response.code, ', message =', response.message)
				return
			}

			this.directionRows = response.data || []
			// make_status=1 이 "열람 중"과 "검수 대기"를 겸하므로, 미처리 검수 요청으로 구분한다
			this.pendingInspections = response.inspections || []
			this.directionUpdatedAt = moment().format('HH:mm:ss')
		},
		/**
		 * 해당 파트에 **도달한** 지시서만 돌려준다.
		 * team_directions 행은 기획이 지시서를 열 때 생기므로, 그대로 뿌리면 아직 넘어오지도 않은
		 * 지시서가 구매·제작에 표시된다. 교육생 화면과 같은 기준으로 맞춘다
		 * — 구매는 기획 완료분(plan_status 2·3), 제작은 구매 완료분(buy_status 2·3).
		 */
		partItems(part, type) {
			return this.directionRows
				.filter(v => v.type === type)
				.filter(v => {
					if (part === 'buy') return v.plan_status === 2 || v.plan_status === 3
					if (part === 'make') return v.buy_status === 2 || v.buy_status === 3
					return true
				})
				.sort((a, b) => a.order > b.order ? 1 : -1)
		},
		partTotal(part) {
			return this.typeDefs.reduce((sum, t) => sum + this.partItems(part, t.key).length, 0)
		},
		isPendingInspection(item) {
			return !!this.pendingInspections.find(v => v.type === item.type && v.order === item.order)
		},
		itemClass(item, part) {
			const status = item[`${part}_status`]

			if (part === 'make' && status === 1 && this.isPendingInspection(item)) return 'pending'

			switch (status) {
				case 1:
					return 'planing'
				case 2:
					return 'completed'
				case 3:
					// 재전송 열람 — 이전에는 미진행과 같은 흰색이라 잠금이 보이지도, 풀리지도 않았다
					return 'resend'
			}
			return ''
		},
		confirmReset(item, part) {
			const status = item[`${part}_status`]

			// 검수 대기 건은 초기화 대상이 아니다 — 초기화하면 접수된 검수 요청이 붕 뜬다
			if (part === 'make' && status === 1 && this.isPendingInspection(item)) {
				this.$store.commit('showDialog', {
					type: 'alert',
					message: '검수 대기 중인 지시서입니다.\n검수 처리로 진행하세요.'
				})
				return
			}

			if (status !== 1 && status !== 3) return

			let message = '선택한 프로젝트를 미완료 상태로 초기화하시겠습니까?'
			if (status === 3) {
				message = '재전송 열람 상태를 완료로 되돌리시겠습니까?'
			} else if (part === 'make') {
				message = '선택한 프로젝트를 검수 전 상태로 초기화하시겠습니까?'
			}

			this.$store.commit('showDialog', {
				type: 'confirm',
				message: message,
				okCb: async _ => {
					const response = await this.$post('/admin/part/direction/reset', {
						id: item.id,
						part: part
					})
					if (response.code !== '0000') {
						console.error('상태 초기화 실패 code =', response.code, ', message =', response.message)
						this.$store.commit('showDialog', {
							type: 'alert',
							message: response.message || '초기화에 실패했습니다.'
						})
					} else {
						// 초기화는 DB 만 바꾼다 — 교육생 화면이 스스로 알 방법이 없으므로 직접 알린다.
						//   'direction' 이 아니라 'direction_reset' 으로 보내는 이유: engine 은 part 토픽에서
						//   'direction' 만 처리하므로 이 액션을 무시한다. engine 이 처리하면 캐시에 남은
						//   유령을 보고 "다른 팀원이 열고 있다"며 방금 푼 상태를 되살릴 수 있다.
						await this.$publish({
							type: 'part',
							trainingId: this.training.id,
							team: item.team,
							part: part,
							action: 'direction_reset',
							message: {
								id: item.id,
								type: item.type,
								order: item.order,
								part: part,
								team: item.team,
							},
						})
					}

					await this.getDirectionList()
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.app-bar-wrap {
	position: sticky;
	left: 0;
	top: 0;
	width: 100%;
	z-index: 10;
	
	background-color: #C10D0D;
	
	.app-bar {
		height: 100px;
		padding: 0 20px;
		
		.status {
			color: #fff;
		}
		
		.training {
			height: 35px;
			background-color: #fff;
			border-radius: 20px;
			
			padding: 3px 20px 0;
			color: #222222;
			
			.training_label {
				color: #C10D0D;
				padding-right: 5px;
			}
		}
		
		.btn-logout {
			cursor: pointer;
		}
	}
	
	.gnb-wrap {
		height: 50px;
		
		background-color: #fff;
		border-top-left-radius: 50px;
		border-top-right-radius: 50px;
		
		padding: 0 50px;
		color: #BCBCBC;
		
		.menu {
			position: relative;
			display: inline-block;
			border-bottom: 2px solid #BCBCBC;
			padding: 5px;
			margin-right: 50px;
			
			cursor: pointer;
			
			&.active {
				color: #C10D12;
				border-bottom-color: #C10D12;
				cursor: default;
			}
			
			.sub-menu {
				position: absolute;
				left: 0;
				top: 34px;
				border: 1px solid #C10D12;
				padding: 0;
				z-index: 1;
				
				.v-list-item:hover {
					background-color: #ffe3e4;
				}
				.v-list-item + .v-list-item {
					border-top: 1px solid #C10D12;
				}
			}
		}
		
		.btn-direction-reset {
			position: absolute;
			right: 15px;
		}
	}
}

.direction-reset {
	.legend-col {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;
	}
	.refresh-wrap {
		display: flex;
		align-items: center;
		margin-left: 12px;

		.updated-at {
			font-size: 12px;
			color: #999;
			margin-right: 8px;
		}
	}
	.legend-hint {
		font-size: 13px;
		color: #666;

		.chip {
			display: inline-block;
			padding: 3px 10px;
			margin-left: 6px;
			border-radius: 12px;
			border: 1px solid #efefef;

			&.chip-planing { background-color: #FEC6C7; border-color: #FDA3A3; }
			&.chip-completed { background-color: #C10D12; border-color: #A51116; color: #fff; }
			&.chip-resend { background-color: #FFD8A8; border-color: #F5A623; }
			&.chip-pending { background-color: #fff; border: 2px dashed #1E6FD9; color: #1E6FD9; }
		}
	}
	.parts {
		margin-top: 10px;
		max-height: 700px;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 10px;
		background-color: #f9f9f9;

		.part-block {
			margin-bottom: 12px;
			padding: 8px 10px;
			border-radius: 8px;
			background-color: #fff;
			border: 1px solid #eee;

			.part-name {
				font-size: 15px;
				font-weight: bold;
				margin-bottom: 4px;
			}

			.part-empty {
				font-size: 13px;
				color: #aaa;
				padding: 6px 2px;
			}

			.type-row {
				.type-name {
					width: 24px;
					font-size: 13px;
					color: #888;
					flex-shrink: 0;
				}

				.items {
					display: flex;
					flex-wrap: wrap;
				}

				.item {
					display: inline-flex;
					font-size: 13px;
					width: 56px;
					height: 44px;
					border-radius: 8px;
					border: 1px solid #efefef;
					background-color: #fff;

					margin: 3px;

					cursor: default;

					&.planing {
						background-color: #FEC6C7;
						border-color: #FDA3A3;
						cursor: pointer;
					}
					&.completed {
						background-color: #C10D12;
						border-color: #A51116;
						color: #fff;
					}
					/* 재전송 열람(3) — 미진행(흰색)과 구분되는 색 + 초기화 가능 */
					&.resend {
						background-color: #FFD8A8;
						border-color: #F5A623;
						cursor: pointer;
					}
					/* 검수 대기 — 초기화 대상 아님(클릭 시 안내만) */
					&.pending {
						border: 2px dashed #1E6FD9;
						color: #1E6FD9;
						cursor: pointer;
					}
				}
			}
		}
	}
}
</style>
